const store_filter = () => {
  const form = document.querySelector('#search_shop');
  const storeListContainer = document.querySelector(".p-store-list__list");
  if(form != null){

    // XMLHttpRequestを使ってjsonデータを読み込む
    const requestURL = "/data/store.json"; //jsonへのパス
    const request = new XMLHttpRequest();
    request.open("GET", requestURL);
    request.responseType = "json";
    request.send();

    //ストア一覧の表示エリア
    let storeList = "";
    let areaList = "";

    // JSONデータの取得
    request.onload = function () {
      let json = request.response;
      json = JSON.parse(JSON.stringify(json));

      //jsonからストア一覧を取得
      storeList = json.store_list;
      areaList = json.area;

      let url = new URL(window.location.href);
      let params = url.searchParams;

      //店舗名で検索した場合
      let queryWord = params.get("word");
      if (queryWord) {
        storeList = filterStoresByShopName(queryWord);
        document.querySelector(".js-store-list-title").innerHTML = queryWord + "の検索結果";
      }

      if (storeListContainer) {
        if (location.pathname == "/store/list/") {
          storeList.forEach(renderStoreHtml);
          document.querySelector(".js-store-list-count-num").innerHTML = storeList.length;
        }
      }

      onloadFunction();
    };

    //ストアの表示処理
    function renderStoreHtml(store) {
      let listItem = document.createElement("li");
      listItem.className = "p-store-list__list__item";

      let titleElement = document.createElement("div");
      titleElement.className = "p-store-list__list__item__title";
      titleElement.textContent = store.title;

      let contentElement = document.createElement("div");
      contentElement.className = "p-store-list__list__item__content";

      if (store.text) {
        let textData = document.createElement("p");
        textData.className = "p-store-list__list__item__content__text";
        var decodedText = htmlDecode(store.text);
        textData.innerHTML = decodedText;
        contentElement.appendChild(textData);
      }

      let shopInfoElement = document.createElement("div");
      shopInfoElement.className = "p-store-list__list__item__content__main";

      let zipcodeElement = document.createElement("p");
      zipcodeElement.innerHTML = "〒" + store.zipcode;

      let addressElement = document.createElement("p");
      addressElement.innerHTML = store.address;

      let telElement = document.createElement("p");
      telElement.innerHTML = "Tel：" + store.tel;

      let businessHourElement = document.createElement("p");
      businessHourElement.innerHTML = "営業時間：" + store.businesshour;

      shopInfoElement.appendChild(zipcodeElement);
      shopInfoElement.appendChild(addressElement);
      shopInfoElement.appendChild(telElement);
      shopInfoElement.appendChild(businessHourElement);
      contentElement.appendChild(shopInfoElement);

      let btnAreaElement = document.createElement("div");
      btnAreaElement.className = "p-store-list__list__item__btn-area";

      let btnAreaInnerElement = document.createElement("div");
      btnAreaInnerElement.className = "p-store-list__list__item__btn-area__in";

      if (store.shop_url_id) {
        let detailBtn = document.createElement("a");
        detailBtn.href = "http://sasp.mapion.co.jp/b/mandai/info/" + store.shop_url_id;
        detailBtn.target = "_blank";
        detailBtn.className = "c-btn c-btn--red";
        detailBtn.textContent = "詳細・チラシ";
        btnAreaInnerElement.appendChild(detailBtn);
      }

      if (store.accessibility) {
        let accessibilityBtn = document.createElement("a");
        accessibilityBtn.href = "https://www.mandai-net.co.jp/shopsearch/img/barrier_free/" + store.accessibility;
        accessibilityBtn.target = "_blank";
        accessibilityBtn.className = "c-btn c-btn--red-border";
        accessibilityBtn.innerHTML = 'バリアフリー<span class="c-icon c-icon--pdf u-ml--8"></span>';
        btnAreaInnerElement.appendChild(accessibilityBtn);
      }

      btnAreaElement.appendChild(btnAreaInnerElement);
      listItem.appendChild(titleElement);
      listItem.appendChild(contentElement);
      listItem.appendChild(btnAreaElement);
      storeListContainer.appendChild(listItem);
    }

    //店舗名でのフォームの送信
    function submitSearchShopForm(event) {
      event.preventDefault(); // フォームのデフォルトのsubmitを防ぐ
      let elmSearchWord = document.querySelector(".js-form__input");
      let searchWord = elmSearchWord.value;

      if (searchWord != "") {
        window.location.href = "/store/list?word=" + searchWord;
      } else {
        elmSearchWord.reportValidity();
      }
    }

    //都道府県・市区町村でのフォームの送信
    function submitSearchPrefForm(event) {
      event.preventDefault(); // フォームのデフォルトのsubmitを防ぐ
      let elmSearchPref = document.getElementById("js-search-pref");
      let searchPref = elmSearchPref.value;

      if (searchPref != "") {
        let redirectUrl = document.getElementById("js-search-city").value;
        window.location.href = "/store/" + redirectUrl;
      } else {
        elmSearchPref.reportValidity();
      }
    }

    //ストアの絞り込み処理
    function filterStoresByShopName(queryWord) {
      let filteredStores = storeList.filter(function (store) {
        return store.title.includes(queryWord);
      });

      return filteredStores;
    }

    // 都道府県に対応する市区町村リストを取得
    function getSubAreaList() {
      let queryPref = document.getElementById("js-search-pref").value;

      // 対応する市区町村のサブエリアリストを取得
      let subAreaList = areaList.find(function (area) {
        return area.pref === queryPref;
      });

      showSubAreaList(subAreaList);
    }

    function showSubAreaList(subAreaList) {
      // 取得した市区町村リストをselect要素に追加
      if (subAreaList) {
        let subAreaSelect = document.getElementById("js-search-city"); // 追加

        // 新たな選択肢を生成する前に、既存の選択肢をクリアする
        subAreaSelect.innerHTML = "<option value='" + subAreaList.category + "'>すべての市区町村</option>";
        subAreaList.city.forEach(function (subArea) {
          let option = document.createElement("option");
          option.value = subAreaList.category + "/" + subArea.category;
          option.textContent = subArea.name;
          subAreaSelect.appendChild(option);
        });
      }
    }

    function onloadFunction() {
      document.getElementById("search_shop").addEventListener("submit", submitSearchShopForm);
      document.getElementById("js-search-pref").addEventListener("change", getSubAreaList);
      document.getElementById("search_area").addEventListener("submit", submitSearchPrefForm);
    }
  }
}

//エスケープされた店舗情報をdecodeする
function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}